import { createTool } from '@mastra/client-js'
import { z } from 'zod'
import store from 'src/store'
import { actions as appActions } from 'src/store/modules/app'

import { IUseRouterObjectPageSearchQuery } from 'src/hooks/router/useRouterObjectPage'

export const navigateToObjectTool = createTool({
  id: 'navigate-to-object',
  description:
    'Navigate to a specific CRM object page. Use this when user wants to view details of a contact, deal, company, or any other CRM object.',
  inputSchema: z.object({
    childrenSchemeIdentifier: z
      .string()
      .optional()
      .describe(
        'Unique identifier scheme of the children object to navigate to'
      ),
    childrenUniqId: z
      .string()
      .optional()
      .describe('Unique identifier of the children object to navigate to'),
    parentUniqId: z
      .string()
      .describe('Unique identifier of the parent object to navigate to'),
    parentSchemeIdentifier: z
      .string()
      .describe('Unique identifier scheme of the parent object to navigate to'),
  }),
  outputSchema: z.object({
    success: z.boolean(),
    message: z.string(),
  }),
  execute: async ({ context }) => {
    const {
      parentSchemeIdentifier,
      parentUniqId,
      childrenSchemeIdentifier,
      childrenUniqId,
    } = context

    const querySearch: IUseRouterObjectPageSearchQuery = {
      objectPage: {
        selectedChildren:
          childrenSchemeIdentifier && childrenUniqId
            ? {
                schemeName: childrenSchemeIdentifier,
                objectUniqId: childrenUniqId,
              }
            : undefined,
      },
    }
    store.dispatch(
      appActions.navigate({
        path: `/storage/${parentSchemeIdentifier}/${parentUniqId}`,
        search: querySearch,
      })
    )

    return {
      success: true,
      message: `Navigating to object `,
    }
  },
})
